import React from "react";
import {createRoot} from "react-dom/client";
import RemoteControl from "./RemoteControl";


const rootElement = document.getElementById("root");
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<RemoteControl/>);
}
